export default "__VITE_ASSET__Pl4Q4$MF__"